import { useGetCurrencyRateQuery } from '@api/api';

export default function useInterestRate() {
  const { data } = useGetCurrencyRateQuery();
  return parseFloat(String(data?.data?.interest_rate || 0));
}
